import fetch from '@/utils/fetch'
// 獲取經銷商列表
export function getList (query) {
  return fetch({
    url: '/adapay/member/list',
    method: 'get',
    params: query
  })
}

// 獲取省市
export function getAreaList (query) {
  return fetch({
    url: '/adapay/corp_member/get_area',
    method: 'get',
    params: query
  })
}
// 獲取銀行
export function getBankList (query) {
  return fetch({
    url: '/adapay/corp_member/get_bank',
    method: 'get',
    params: query
  })
}

// 建立企業使用者物件
export function createCorp (query) {
  return fetch({
    url: '/adapay/corp_member/create',
    method: 'post',
    params: query
  })
}
// 更新企業使用者物件
export function updateCorp (id, query) {
  return fetch({
    url: `/adapay/corp_member/update/${id}`,
    method: 'post',
    params: query
  })
}
// 建立個人使用者物件
export function createPerson (query) {
  return fetch({
    url: '/adapay/member/create',
    method: 'post',
    data: query
  })
}
// 更新個人使用者物件
export function updatePerson (id, query) {
  return fetch({
    url: '/adapay/member/update/' + id,
    method: 'post',
    data: query
  })
}

// 檢視  帳戶型別（個人）
export function checkPerson (id) {
  return fetch({
    url: `/adapay/member/get/${id}`,
    method: 'get'
  })
}
// 檢視 帳戶型別（企業）
export function checkCorp (id) {
  return fetch({
    url: `/adapay/corp_member/get/${id}`,
    method: 'get'
  })
}

// 檢視 帳戶型別（企業）
export function getConfirmLetterFile (id) {
  return fetch({
    url: `/adapay/corp_member/get_file_url/${id}`,
    method: 'get'
  })
}

// 個人提交
export function submitReviewPerson (query) {
  return fetch({
    url: `/adapay/member/submit_review/`,
    method: 'get',
    params: query
  })
}

// // 企業提交
// export function submitReviewCorp(query){
//   return fetch({
//     url:`/adapay/member/submit_review/`,
//     method:'get',
//     params: query
//   })
// }

// 檢視使用者狀態
export function userStatus () {
  return fetch({
    url: '/adapay/member/auditState',
    method: 'get'
  })
}
